import React from 'react';
import { IconButton } from '@mui/material';
import { emailadminService } from '../EmailAdministrationService';
import { useHistory } from 'react-router-dom';
import { ThemedDeleteIcon } from '../../../../Common/Components/Icons';
import { TFunction } from 'i18next';
import { showToast } from '../../../../lib/toast';

const DeleteTemplate = (props: {
  templateName: string;
  loadEmailTemplates: () => Promise<void>;
  t: TFunction<'translation', undefined>;
}) => {
  const history = useHistory();
  const handleClick = () => {
    const confirm = window.confirm(
      props.t('emailAdmin.alert.deleteTemplate', {
        template: props.templateName,
      }),
    );
    if (confirm) {
      emailadminService
        .deleteEmailTemplate(props.templateName)
        .then((template) => {
          props.loadEmailTemplates();
          showToast({
            type: 'success',
            title: props.t('emailAdmin.success.templateDeleted', {
              template: template.Name,
            }),
          });
          history.push('/emailadministration');
        });
    }
  };

  return (
    <IconButton onClick={handleClick}>
      <ThemedDeleteIcon />
    </IconButton>
  );
};

export default DeleteTemplate;
